import { render, staticRenderFns } from "./upload-bill-multi-custom.vue?vue&type=template&id=6270faf8&"
import script from "./upload-bill-multi-custom.vue?vue&type=script&lang=js&"
export * from "./upload-bill-multi-custom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "upload-bill-multi-custom.vue"
export default component.exports